<div class="row">
    <div class="col-sm-9">
      <div class="booking_ht">
  <!-- <sm-title-bar pageTitle="All expenditure"></sm-title-bar> -->
  <sm-title-bar pageTitle="All expenditure" [backWithParams]="true"></sm-title-bar>

  </div>
  </div>
  <div class="col-sm-3">
    <!-- <div class="search_bar_custom">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search for services">
          <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
  </div> -->
  </div>
  </div>
  
  <mat-card *ngIf="!loader && expenditureData.length > 0">
      <div class="rounded-3 bg-light">
        <sm-data-table [columnHeaders]="tableDisplayColumns" 
                       [showImageColumn]="true" 
                       [imageTemplate]="image" 
                       [dataSource]="expenditureData" 
                    
                       [showPagination]="true" 
                       [itemsPerPage]="25">
        </sm-data-table>
      </div>
    </mat-card>
    <ng-template #menuTemplate let-rowvalue>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span>edit</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span>Delete</span>
      </button>
    </ng-template>
    <ng-template #image let-objValue>
      <div class="bookign_crim">
        <mat-icon *ngIf="objValue['expense_type'] == 1">receipt</mat-icon>
        <mat-icon *ngIf="objValue['expense_type'] == 2">local_mall</mat-icon>
        <mat-icon *ngIf="objValue['expense_type'] == 3">payments</mat-icon>
     </div>
      <!-- <img
        [src]="
          objValue['image'] !== null && objValue['image'] !== 'null' && objValue['image'] !== ''
            ? objValue['image']
            : './assets/images/photo.png'
        "
        class="img-fluid rounded-circle"
      /> -->
    </ng-template>